import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { BaseView, BaseText } from '@/components/base'
import { ChevronRight } from '@/assets/icons'
import { useTheme } from '@/hooks/useTheme'
import { useSavingsStore } from '@/store/useSavingsStore'
import { AdaptedSavingGoalDTO } from '@/domain/transfer'

export interface GoalCardProps {
  savingGoal?: AdaptedSavingGoalDTO
  skeletonActive?: boolean
}

export const GoalCard: React.FC<GoalCardProps> = ({
  savingGoal,
  skeletonActive,
}) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const navigate = useNavigate()
  const setGoal = useSavingsStore((state) => state.setGoal)
  const setSavingGoalId = useSavingsStore((state) => state.setSavingGoalId)

  if (skeletonActive) {
    return (
      <BaseView
        style={{
          backgroundColor: theme.colors.background.secondaryGray,
          borderRadius: 26,
          padding: 16,
          height: 84,
          width: '100%',
        }}
        className="animate-pulse"
      />
    )
  }

  const handlePress = () => {
    if (savingGoal) {
      // Устанавливаем ID цели для режима редактирования
      setSavingGoalId(savingGoal.id || '')
      setGoal({
        name: savingGoal.name,
        category: savingGoal.category,
        isFiatMode: false,
        cryptoAmount: {
          amount: savingGoal.goal_amount || '0',
          code: 'USDT',
        },
        fiatAmount: {
          amount: parseFloat(savingGoal.goal_amount || '0').toString(),
          code: 'USD',
        },
      })

      navigate('/savings/select')
    }
  }

  return (
    <BaseView
      row
      align="center"
      gap={12}
      style={{
        backgroundColor: '#222425',
        borderRadius: 26,
        paddingLeft: 12,
        paddingRight: 12,
        paddingTop: 12,
        paddingBottom: 12,
        cursor: 'pointer',
        transition: 'all 0.2s ease',
      }}
      className="hover:opacity-80 active:scale-[0.98]"
      onClick={handlePress}
    >
      {/* Goal Emoji */}
      <BaseView
        center
        style={{
          backgroundColor: theme.colors.background.screen,
          borderRadius: 22,
          width: 68,
          height: 68,
        }}
      >
        <BaseText fontSize={22}>{savingGoal?.category || '💰'}</BaseText>
      </BaseView>

      {/* Goal Info */}
      <BaseView flex={1}>
        <BaseText
          fontSize={17}
          fontFamily="bold"
          style={{
            // color: theme.colors.label.primary,
            marginBottom: 2,
          }}
        >
          {t('translation:goal.goal')}{' '}
          {savingGoal?.goalAmountFormatted || '$0.00'}
        </BaseText>
        <BaseText
          fontSize={15}
          fontFamily="semibold"
          style={{
            color: theme.colors.label.description,
          }}
        >
          {t('translation:goal.changeYourGoal')}
        </BaseText>
      </BaseView>

      {/* Chevron Right */}
      <ChevronRight size={24} color={theme.colors.label.description} />
    </BaseView>
  )
}
